export default function Features() {
  const features = [
    {
      icon: 'ri-funds-box-line',
      title: 'Cash Flow Stabilization',
      description: 'Our cash flow forecast model gives distressed businesses the visibility and control they need to survive and recover.',
      link: 'Learn More',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Structured Turnarounds',
      description: 'Cost-effective turnarounds built on a highly structured approach with a fixed fee and fixed timeline, so you always know what to expect.',
      link: 'Explore',
    },
    {
      icon: 'ri-shake-hands-line',
      title: 'Creditor & Lender Solutions',
      description: 'We represent you in negotiations with lenders and creditors to determine the best financial path forward — protecting your business and your relationships.',
      link: 'Get Started',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-5xl lg:text-6xl font-serif font-bold text-slate-900 leading-tight">
              The Only Solution for Distressed Companies
            </h2>
          </div>
          <div className="flex items-center">
            <p className="text-gray-600 text-lg leading-relaxed">
              We are passionate about helping businesses maximize opportunities and solve financial challenges at an affordable cost and in an empathetic manner. Our goal is to educate you on cash flow and operational best practices so you can grow, meet your obligations to creditors, and thrive.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-orange-500 transition-all hover:shadow-xl flex flex-col"
            >
              <div className="w-16 h-16 bg-orange-500 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-6 flex-grow">{feature.description}</p>
              <a
                href="#"
                className="inline-flex items-center gap-2 text-orange-600 font-semibold hover:gap-3 transition-all cursor-pointer mt-auto"
              >
                {feature.link}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}